module.exports = __webpack_public_path__ + "static/media/dualcore2.debb2a9b.png";